/* import __COLOCATED_TEMPLATE__ from './status-option.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

interface FiltersStatusOptionSignature {
  Args: {
    hideCount: unknown;
    label: unknown;
    status: unknown;
  };
  Element: HTMLElement;
}

const FiltersStatusOptionComponent = templateOnlyComponent<FiltersStatusOptionSignature>();

export default FiltersStatusOptionComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Filters::StatusOption': typeof FiltersStatusOptionComponent;
    'filters/status-option': typeof FiltersStatusOptionComponent;
  }
}
